"use client";
import * as React from "react";
const SvgFavoriteRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M9.08 13.59a1.606 1.606 0 0 1-2.152-.008l-.088-.079C2.642 9.735-.1 7.268.003 4.19A4.322 4.322 0 0 1 1.874.786C3.985-.642 6.592.024 8 1.659 9.407.024 12.014-.65 14.125.786a4.322 4.322 0 0 1 1.872 3.403c.112 3.079-2.64 5.546-6.838 9.33l-.08.071Z" }));
export {
  SvgFavoriteRound as default
};
